import { AxiosError } from "axios";

export class SMVError extends Error {
	constructor(cause: unknown, fallback = "Something went wrong. Please try again.") {
		const message =
			cause instanceof AxiosError ? (cause.response?.data?.message ?? fallback) : fallback;
		super(message);
		this.name = "SMVError";
	}
}
